export const ID_CARD_FIELDS = [
  'UserId',
  'Name',
  'Designation',
  'Email',
  'MobileNumber',
  'BloodGroup',
  'EmployeeId',
  'PhotoId',
  'ApplicationType',
  'PaymentMethod',
  'PaymentReference',
  'PaymentReferenceId',
  'Status',
  'AppliedDateUtc',
  'ApprovedBy',
  'ApprovedByName',
  'ApprovedDateUtc',
  'ApprovalStatusReason',
  'DepartmentId',
  'Timezone',
] as const;
